<template>
  <div class="main-container">
    <LoadingQuote v-if="finishedLoading == false" v-on:finishedLoading="finishedAnimation"/>
    <LandingStructure v-if="finishedLoading == true"/>
    <div class="background-image"></div>
    <div class="overlay"></div>
  </div>
</template>

<script>
import TvaHeader from "@/components/TvaHeader.vue";
import TvaSideNav from "@/components/TvaSideNav.vue";
import TvaCard from "@/components/TvaCard.vue";
import TvaSvgIcons from "@/components/TvaSvgIcons.vue";
import TvaContentSwitcher from "@/components/TvaContentSwitcher.vue";
import TvaCheckbox from "@/components/TvaCheckbox.vue";
import TvaBreadcrumb from "@/components/TvaBreadcrumb.vue";
import TvaSliderContainer from "@/components/TvaSliderContainer.vue";
import TvaSimpleButton from "@/components/TvaSimpleButton.vue";

import TvaScroller from "@/utilities/TvaScroller.vue";
import TvaParallax from "@/utilities/TvaParallax.vue";
import TvaBodymovin from "@/utilities/TvaBodymovin.vue";
import TvaVideoPlayer from "@/utilities/TvaVideoPlayer.vue";
import TvaDropdown from "@/utilities/TvaDropdown.vue";

import LoadingQuote from "@/components/LoadingQuote.vue";
import LandingStructure from "@/components/LandingStructure.vue";

import _ from "lodash";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Main",
  data() {
    return {
      sections: null,
      index: 0,
      progress: 0,
      offset: 0,
      activeSections: [],
      direction: "",
      baseUrl: process.env.BASE_URL,
      typeOptions: {
        height: "40vh",
        background: "red"
      },
      finishedLoading: false
    };
  },
  created() {
    this.sections = _.cloneDeep(this.$ml.get("sections"));
  },
  computed: {
    ...mapGetters(["count"])
  },
  methods: {
    ...mapActions(["increment"]),
    finishedAnimation(){
      this.finishedLoading = true
    }
  },
  components: {
    TvaScroller,
    TvaParallax,
    TvaBodymovin,
    TvaVideoPlayer,
    TvaDropdown,
    TvaSimpleButton,
    TvaBreadcrumb,
    TvaContentSwitcher,
    TvaCheckbox,
    TvaHeader,
    TvaSideNav,
    TvaSliderContainer,
    TvaSvgIcons,
    TvaCard,
    LoadingQuote,
    LandingStructure
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/fonts.scss";
.main-container{
  .background-image{
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100vh;
    background-image: url("/images/sfondo.jpg");
    z-index: -2;
  }
  .overlay{
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100vh;
    background-color: black;
    opacity: 20%;
    mix-blend-mode: multiply;
    z-index: -1;
  }
}
</style>
